import * as React from 'react';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { IPageContentImage } from '../../types/Content';
import { memo, useEffect, useState } from 'react';
import { fetchWithAuthentication } from '../../actions/BaseAction'

interface IImageProps {
  image: IPageContentImage;
  tileImage?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    imageContainer: {
      width: '100%',
      padding: '0 0 10px',
      textAlign: 'center',
    },
    image: {
      width: '100%',
      height: 'auto',
    },
    fillContainerRoot: {
      width: '100%',
      height: '100%',
      padding: 0,
      textAlign: 'center',
    },
    fillImageElement: {
      width: '100% !important',
      height: '100% !important',
      objectFit: 'cover',
    },
  })
);

const Image: React.FC<IImageProps> = memo(({ image, tileImage }): JSX.Element => {
  const classes = useStyles({});
  const [imageSrc, setImageSrc] = useState('data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');

  useEffect(() => {
    fetchWithAuthentication(image.url)
      .then(blob => {
        if (blob !== null) {
          setImageSrc(URL.createObjectURL(blob));
        }
      })
      .catch(error => {throw error});
  }, [image.url]);

  return (
    <div className={tileImage ? classes.fillContainerRoot : classes.imageContainer}>
      <img
        className={tileImage ? classes.fillImageElement : classes.image}
        src={imageSrc}
        alt={image.name} />
    </div>
  );
});

export default Image;
